import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import Link from '@mui/material/Link'
import styles from './Checkout.module.css'
import { Button, CardActions } from '@mui/material'
import { useTranslation } from 'react-i18next'
export default function CardTrial() {
  const { t } = useTranslation()
  return (
    <Card
      variant="outlined"
      className={styles.trial_card}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '15px',
        height: '100%'
      }}
    >
      <CardContent>
        <div className={styles.trial_card_header}>
          <div className={styles.trial_card_header_inner}>
            <p>{t('pro')}</p>

            <span>({t('billedYearly')})</span>
          </div>

          <p>9.99$</p>
        </div>

        <Divider />
        <Link href="#">
          <p>{t('haveAPromoCode')}</p>
        </Link>
        <Divider />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p>{t('todayYouPayInUSDollars')}</p>
          <p>0$</p>
        </div>
        <p>{t('after21Days')}: 119$</p>
      </CardContent>

      <CardActions sx={{ marginTop: 'auto' }}>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: '#1e75ff',
            borderRadius: '10px',
            height: '3rem'
          }}
        >
          {t('tryForFreeForDays')}
        </Button>
      </CardActions>
    </Card>
  )
}
